import { Component, Input } from '@angular/core';
import { FrontendFieldDefinition } from '../../models/frontend-field-definition.model';
import { FrontendFormDefinition } from '../../models/frontend-form-definition.model';

@Component({
  selector: 'app-sm-form-group',
  templateUrl: './sm-form-group.component.html',
  styleUrl: './sm-form-group.component.scss'
})
export class SmFormGroupComponent {

    @Input()
    form: FrontendFormDefinition = null;
    @Input()
    fields: FrontendFieldDefinition[][] = [];
}
